import { Feature } from '@/pinia/feature'

export const ibinder: Feature = {
  name: 'ibinder',
  enabled: false,
  access: [
    'FEAT_IBINDER_ADMIN',
    'FEAT_IBINDER_CREATOR',
    'FEAT_IBINDER_EDITOR',
    'FEAT_IBINDER_READER'
  ],
  title: {
    en: 'iBinder',
    sv: 'iBinder'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconBook',
    disableIsDrawPointActive: true,
    enableFullscreen: true,
    subtitle: {
      sv: 'iBinder',
      en: 'iBinder'
    }
  },
  children: [
    {
      title: {
        en: 'iBinder',
        sv: 'iBinder'
      },
      name: 'ibinder',
      enabled: true,
      children: [
        {
          name: 'ibinder',
          enabled: true,
          title: {
            en: 'iBinder',
            sv: 'iBinder'
          },
          component: 'IBinderDashboard',
          isRoute: true,
          props: {
            icon: 'IconBook'
          },
          children: []
        }
      ]
    }
  ]
}
